export const IAStatusCodes = {
  MaxFrontOrBackSidesExceded: 464,
  RequiredBackSide: 463,
  RequiredFrontSide: 462,
  RequiredPDFType: 461,
};
